export default function customerProtocolFormReducer(state, action) {
    switch (action.type) {
        case 'POST_CUSTOMER_PROTOCOLS_SUCCESS':
            return undefined; // <--- blow away form data

        default:
            return state;
    }
}
